<article class="blog-article blog-article--skeleton" *ngIf="isLoading" aria-hidden="true">
    <header class="blog-article__hero">
        <div class="container">
            <div class="blog-article__breadcrumbs">
                <span class="blog-detail-skeleton blog-detail-skeleton--crumb"></span>
            </div>
            <div class="blog-article__hero-grid">
                <div>
                    <span class="blog-detail-skeleton blog-detail-skeleton--date"></span>
                    <span class="blog-detail-skeleton blog-detail-skeleton--h1"></span>
                    <span class="blog-detail-skeleton blog-detail-skeleton--h1 blog-detail-skeleton--h1-short"></span>
                    <span class="blog-detail-skeleton blog-detail-skeleton--lead"></span>
                    <span class="blog-detail-skeleton blog-detail-skeleton--lead blog-detail-skeleton--lead-short"></span>
                </div>
                <figure>
                    <span class="blog-detail-skeleton blog-detail-skeleton--hero-image"></span>
                </figure>
            </div>
        </div>
    </header>

    <div class="container blog-article__layout">
        <main>
            <section class="blog-article__content">
                <span class="blog-detail-skeleton blog-detail-skeleton--section-title"></span>
                <span class="blog-detail-skeleton blog-detail-skeleton--paragraph" *ngFor="let item of contentSkeletonRows"></span>
                <span class="blog-detail-skeleton blog-detail-skeleton--content-image"></span>
            </section>
        </main>

        <aside>
            <div class="blog-article__aside-card">
                <span class="blog-detail-skeleton blog-detail-skeleton--aside-label"></span>
                <span class="blog-detail-skeleton blog-detail-skeleton--aside-title"></span>
                <span class="blog-detail-skeleton blog-detail-skeleton--aside-text"></span>
                <span class="blog-detail-skeleton blog-detail-skeleton--aside-link"></span>
            </div>
        </aside>
    </div>
</article>

<article class="blog-article" *ngIf="!isLoading && hasLoadError">
    <div class="container blog-article__layout">
        <main>
            <section class="blog-article__content">
                <h1>Материал не загрузился</h1>
                <p>Попробуйте обновить страницу.</p>
            </section>
        </main>
    </div>
</article>

<article class="blog-article" [class.blog-article--cost-km]="shouldShowCostPerKmCalculator()" *ngIf="post">
    <header class="blog-article__hero">
        <div class="container">
            <nav aria-label="breadcrumb" class="blog-article__breadcrumbs">
                <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item" data-aos="fade-down">
                        <a routerLink="/">Главная</a>
                    </li>
                    <li class="breadcrumb-item" data-aos="fade-down" data-aos-delay="70">
                        <a routerLink="/blog">Блог</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page" data-aos="fade-down" data-aos-delay="140">
                        {{ post.breadcrumb || post.h1 }}
                    </li>
                </ol>
            </nav>
            <div class="blog-article__hero-grid">
                <div data-aos="fade-up">
                    <time *ngIf="post.published_at">{{ post.published_at | date:'dd.MM.yyyy' }}</time>
                    <h1 data-aos="fade-right" data-aos-delay="70">{{ post.h1 }}</h1>
                    <p>{{ post.excerpt || post.description }}</p>
                    <div class="blog-article__hero-promise" *ngIf="shouldShowCostPerKmCalculator()">
                        <span>Полная стоимость</span>
                        <span>Быстрый расчёт</span>
                        <span>По вашим данным</span>
                    </div>
                </div>
                <figure *ngIf="post.hero_image" data-aos="zoom-out" data-aos-delay="120">
                    <img
                        [src]="post.hero_image.display_url || post.hero_image.url"
                        [alt]="post.hero_image.alt"
                        loading="eager"
                        fetchpriority="high"
                        decoding="async"
                    >
                </figure>
            </div>
        </div>
    </header>

    <div #costCalculatorContainer
         class="container blog-article__calculator"
         *ngIf="shouldShowCostPerKmCalculator()">
        <app-public-cost-per-km-calculator data-aos="fade-up"></app-public-cost-per-km-calculator>
    </div>

    <div class="container blog-article__layout">
        <main>
            <section class="blog-article__content" [innerHTML]="contentHtml" data-aos="fade-up"></section>

            <section class="blog-article__gallery" *ngIf="post.gallery.length" data-aos="fade-up">
                <h2>Галерея</h2>
                <div>
                    <figure *ngFor="let image of post.gallery; let imageIndex = index"
                            data-aos="fade-up" [attr.data-aos-delay]="getAosDelay(imageIndex, 80, 240)">
                        <img [src]="image.thumb_url" [alt]="image.alt" loading="lazy" decoding="async">
                        <figcaption *ngIf="image.title">{{ image.title }}</figcaption>
                    </figure>
                </div>
            </section>

            <app-faq-section [items]="post.faq" [animated]="true"></app-faq-section>
        </main>

        <aside>
            <div class="blog-article__aside-card" data-aos="fade-left" data-aos-delay="90">
                <div class="blog-article__aside-label">MotorDesk</div>
                <h2>Начните вести данные своей машины</h2>
                <p>Расходы, пробег, заправки, обслуживание и план будущих работ удобно собирать в одном кабинете.</p>
                <p class="blog-article__aside-note">Для регистрации нужен e-mail в зоне .ru.</p>
                <a [href]="registrationUrl('blog_sidebar')" (click)="trackRegistrationClick('blog_sidebar')">
                    Создать кабинет
                </a>
                <a class="blog-article__aside-secondary" routerLink="/demo">Сначала посмотреть демо</a>
            </div>
            <div class="blog-article__aside-card" data-aos="fade-left" data-aos-delay="140">
                <div class="blog-article__aside-label">Telegram</div>
                <h2>Следите за новыми материалами</h2>
                <p>В канале публикуются новости MotorDesk, анонсы статей блога и полезные заметки для
                    автовладельцев.</p>
                <a [href]="env.CHANNEL_URL" target="_blank" rel="noopener">Открыть {{ env.CHANNEL_NAME }}</a>
            </div>
        </aside>
    </div>

    <div class="blog-article__mobile-cta"
         *ngIf="shouldShowCostPerKmCalculator() && hasSeenCostCalculator && !isCostCalculatorVisible">
        <div>
            <strong>Сохраните расчёт своей машины</strong>
            <span>Пробег и расходы останутся под рукой</span>
        </div>
        <a [href]="registrationUrl('cost_km_mobile_sticky')"
           (click)="trackCostCalculatorRegistrationClick('cost_km_mobile_sticky')">
            Сохранить
        </a>
    </div>
</article>
